import React from 'react';
import SubHeading from '../contact-subheading';
import classNames from 'classnames';
import Image from '../../Image';

const AboutUsSection = (props) => {
  const heading =
    props.Heading && props.SubSection ? (
      <h4>{props.Heading}</h4>
    ) : props.Heading ? (
      <SubHeading {...props} />
    ) : null;

  return (
    <div
      className={classNames({
        unit__section: true,
        subsection: props.SubSection,
      })}
    >
      {heading}
      <div className="row">
        <div
          className={classNames({
            'large-9': !props.SubSection && !props.FullWidth,
            'large-12': props.FullWidth,
            columns: true,
          })}
        >
          <div className="unit__section__content">
            {props.PhotoUrl && (
              <div className="unit__section__img">
                <Image ImageUrl={props.PhotoUrl} Alt={props.PhotoAlt} />
              </div>
            )}
            {props.Content &&
              props.Content.map((item, index) =>
                item.match(/^\s*$/) !== null ? (
                  <br key={index} />
                ) : (
                  <p key={index} dangerouslySetInnerHTML={{ __html: item }}></p>
                )
              )}
            {props.children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutUsSection;
